
import { Link } from "react-router-dom";
import { NavItems } from "@/components/NavItems";
import { ThemeToggle } from "@/components/ThemeToggle";
import { AuthButtons } from "@/components/AuthButtons";
import { MobileMenu } from "@/components/MobileMenu";
import { useAuth } from "@/hooks/useAuth";

export function MainNav() {
  const { isAuthenticated, role, loading } = useAuth();
  
  return (
    <div className="border-b border-border/50 shadow-sm dark:border-border/30 transition-all duration-300">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between py-2">
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center space-x-2">
              <span className="font-bold text-2xl text-gold">Gildy</span>
            </Link>
          </div>
          
          <NavItems 
            isAuthenticated={isAuthenticated} 
            userRole={role}
            className="mx-6 hidden items-center space-x-4 md:flex"
          />
          
          <div className="flex items-center space-x-4">
            <ThemeToggle />
            <AuthButtons />
            <MobileMenu />
          </div>
        </div>
      </div>
    </div>
  );
}
